import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  class: "text-secondary mt-2",
  "font-size": "font-size: 1.8rem;"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "display-3 mt-4" }, "🐞", -1)
const _hoisted_4 = { class: "display-6 mt-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-house",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" })
], -1)

import { useRoute } from 'vue-router';
    import { ref, onMounted } from 'vue';
    import { useMeta } from '@/composables/meta';
    import { dontUseCanonical } from '@/composables/canonical';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    statusCode: null
  },
  setup(__props: any) {

const props = __props as { statusCode: number }

    const route = useRoute();

    
    const header = ref<string>(`${props.statusCode} - Något gick snett!`);
    const text = ref<string>('Sidan du försöker nå är inte tillgänglig. Försök igen!');

    onMounted(async () => {
        useMeta(`Fel ${props.statusCode}`, `Något gick snett, sidan du försöker nå är inte tillgänglig`);
        dontUseCanonical();
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(header.value), 1),
    _hoisted_3,
    _createElementVNode("h2", _hoisted_4, _toDisplayString(text.value), 1),
    _createVNode(_component_router_link, {
      to: { name: 'Start' },
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("button", {
          role: "button",
          onClick: navigate,
          class: "btn btn-primary btn-custom-size mt-5"
        }, [
          _hoisted_6,
          _createTextVNode(" TILL STARTSIDAN ")
        ], 8, _hoisted_5)
      ]),
      _: 1
    })
  ]))
}
}

})